<template>
	<nav class="sidebar-nav">
		<div class="sidebar-header">
			<button class="nav-toggler nav-toggler-md sidebar-toggler" type="button" data-toggle="collapse" data-target="#nav-toggleable-md">
				<span class="sr-only">Toggle nav</span>
			</button>
			<a class="sidebar-brand img-responsive" href="/">
				<img class="logo-image default" src="/static/img/authlogics-logo-white.png"/>
			</a>
		</div>

		<div class="collapse nav-toggleable-md" id="nav-toggleable-md">
			<!--<form class="sidebar-form">
				<input class="form-control" type="text" placeholder="Search...">
				<button type="submit" class="btn-link">
					<span class="icon icon-magnifying-glass"></span>
				</button>
			</form>-->
			<ul v-if="!mode" class="nav nav-pills nav-stacked flex-column">
				<li class="nav-header">Navigation</li>
				
				<!--
				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('home')}" to="/">Dashboard</router-link>
				</li>
				-->
				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('domains,domainDetail,domainResults,domainEmailDetail')}" to="/domains">Domains</router-link>
				</li>
				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('emails,emailDetail')}" to="/emails">Emails</router-link>
				</li>
				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('notifications')}" to="/notifications">Notifications</router-link>
				</li>
				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('breaches')}" to="/breaches">Breaches</router-link>
				</li>
				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('audits')}" to="/audits">Audits</router-link>
				</li>
				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('password')}" to="/password">Password Lookup</router-link>
				</li>

				<li class="nav-header">System</li>
				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('user')}" to="/user">Account</router-link>
				</li>
				<li class="nav-item" v-if="isInRole('SiteAdmin')">
					<router-link class="nav-link" to="/settings/users">Settings</router-link>
				</li>

				<li class="nav-item">
					<router-link class="nav-link" to="/logout">Logout</router-link>
				</li>
			</ul>

			<ul v-if="mode==='settings'" class="nav nav-pills nav-stacked flex-column">
				<li class="nav-header">Settings</li>
			

				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('users')}" to="/settings/users">Users</router-link>
				</li>
				<li class="nav-item" v-if="isInRole('GlobalAdmin')">
					<router-link class="nav-link" :class="{active: isRouteActive('sites')}" to="/settings/sites">Sites</router-link>
				</li>
				<li class="nav-item">
					<router-link class="nav-link" :class="{active: isRouteActive('apikeys')}" to="/settings/apikeys">API Keys</router-link>
				</li>

				<li class="nav-item">
					<router-link class="nav-link icon back" to="/domains"><span>Back</span></router-link>
				</li>
			</ul>
			<hr class="visible-xs mt-3">
		</div>
	</nav>
</template>

<script>
	import router from "../router"
	import store from '../state'

	export default {
		name: 'SideBar',
		props: ['mode'],
		methods: {
			isRouteActive(values) {
				const names = values.split(',');
				return names.indexOf(router.currentRoute.name) > -1;
			},
			isInRole(role) {
				if (!store.state.user || !store.state.user.roles) return;
				return store.state.user.roles.indexOf(role) > -1;
			}
		}
  }
</script>


// WEBPACK FOOTER //
// src/components/SideBar.vue